
import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';
import { ObjectLength } from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";
import CustomTypes from "Flow2/components/CustomCollections/CustomDataConfig/CustomDataTypes";

const initialState = {
    clips: [],
    count: 0,
    error: null,
    loading: false,
    loadingMore: false,
    sortOrder: null,
    sort: { orderBy: 'created', order: 'DESC' },
    customLoading: 0,
    customProjectReload: 0,
    home: {
        loading: [],
        latestvideos: [],
        latestpictures: [],

    }
};

const searchStart = (state, action) => {
    if (action.payload.type.startsWith('latest')) {
        let loading = state.home.loading.slice();
        if (loading.indexOf(action.payload.type) == -1) {
            loading.push(action.payload.type);
        }
        return updateObject(state, { home: updateObject(state.home, { loading: loading, [action.payload.type]: [] }) });
    }
    return updateObject(state, { error: null, loading: true, clips: [], count: 0 });
}

const searchFail = (state, action) => {
    return updateObject(state, {
        error: action.error,
        loading: false
    });
}

const searchNextStart = (state, action) => {
    return updateObject(state, { error: null, loadingMore: true });
}

const searchNextFail = (state, action) => {
    return updateObject(state, {
        error: action.error,
        loadingMore: false
    });
}

const searchSuccess = (state, action) => {

    let clips = [];
    let elements;
    if (action.payload.clips && action.payload.clips.objects && action.payload.clips.objects.elements)
        elements = action.payload.clips.objects.elements;
    else if (action.payload.clips && action.payload.clips.clip && action.payload.clips.clip.elements)
        elements = action.payload.clips.clip.elements;

    Object.keys(elements).forEach(id => {
        let element = elements[id];
        let mediaTypes = [];
        mediaTypes = Object.keys(element.media.fields);
        //if (-1 === clips.findIndex((e) => e.id === element.id)) {
        let index = clips.findIndex((e) => parseInt(e) === parseInt(id));
        if (index === -1) {
            clips.push(element.id);
        }
    });

    let newState = null;

    if (action.payload.type !== 'search') {
        let home = state.home;
        home = updateObject(home, { loading: home.loading.filter(l => l != action.payload.type), [action.payload.type]: clips });
        newState = updateObject(state, {
            home: home
        });
    } else {
        newState = updateObject(state, {
            loading: false,
            error: null,
            clips: clips,
            count: action.payload.clips.count,
        });
    }
    return newState;
}

const searchNextSuccess = (state, action) => {
    let clips = [...state.clips];
    let elements;
    if (action.payload.clips && action.payload.clips.objects && action.payload.clips.objects.elements)
        elements = action.payload.clips.objects.elements;
    else if (action.payload.clips && action.payload.clips.clip && action.payload.clips.clip.elements)
        elements = action.payload.clips.clip.elements;

    Object.keys(elements).forEach(id => {
        let element = elements[id];
        let mediaTypes = [];
        mediaTypes = Object.keys(element.media.fields);
        //if (-1 === clips.findIndex((e) => e.id === element.id)) {
        let index = clips.findIndex((e) => parseInt(e) === parseInt(element.id));
        if (index === -1) {
            clips.push(element.id);
        }
    });

    let newState = updateObject(state, {
        loadingMore: false,
        error: null,
        clips: clips,
        count: action.payload.clips.count
    });
    return newState;
}

const changeSortOrder = (state, action) => {
    if (action.payload.target == 'search') {
        const allClips = action.payload.allClips;
        let clipsCount = ObjectLength(allClips);
        let customLoading = state.customLoading;
        if (state.count > clipsCount) {
            customLoading++;
        }
        const orderBy = action.payload.sortOrder.split('|')[0];
        const order = action.payload.sortOrder.split('|')[1];

        let clips = null;
        if (order == 'ASC') {
            clips = state.clips.slice().sort((id1, id2) => (allClips[id1] && (allClips[id1].metadata[orderBy] > allClips[id1].metadata[orderBy])) ? 1 : -1);
        } else {
            clips = state.clips.slice().sort((id1, id2) => (allClips[id1] && (allClips[id1].metadata[orderBy] > allClips[id1].metadata[orderBy])) ? -1 : 1);
        }

        return updateObject(state, { clips: clips, sort: { orderBy: orderBy, order: order }, customLoading: customLoading });
    }
    else {
        // if (action.payload.sortOrder === "id|DESC") {
        if (action.payload.sortOrder === CustomTypes.SORTING) {
            let customProjectReload = state.customProjectReload;
            customProjectReload++;
            return updateObject(state, { ...state, customProjectReload: customProjectReload });
        }
    }

    return state;
}

//depending on cliplistType we load clips from project, room, cliplist ....
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SEARCH_START: return searchStart(state, action);
        case actionTypes.SEARCH_SUCCESS: return searchSuccess(state, action);
        case actionTypes.SEARCH_FAIL: return searchFail(state, action);
        case actionTypes.SEARCH_NEXT_START: return searchNextStart(state, action);
        case actionTypes.SEARCH_NEXT_SUCCESS: return searchNextSuccess(state, action);
        case actionTypes.SEARCH_NEXT_FAIL: return searchNextFail(state, action);
        case actionTypes.SET_SORTORDER: return changeSortOrder(state, action);
        case actionTypes.SEARCH_SET_SORT_DEFAULT: return { ...state, sort: action.payload };
        case actionTypes.SEARCH_SET_SORTORDER_DEFAULT: return { ...state, sortOrder: action.payload };
        default:
            return state;
    }
}

export default reducer;
